import { Auth } from "aws-amplify";

// Amplify permits only one password sign-in at a time, including across pages.
let pendingSignIn: Promise<unknown> | null = null;
const PENDING_WAIT_MS = 15_000;

function waitForPrevious(previous: Promise<unknown>) {
  return new Promise<void>((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error("Pending sign-in attempt already in progress")), PENDING_WAIT_MS);
    previous.then(
      () => { clearTimeout(timer); resolve(); },
      () => { clearTimeout(timer); resolve(); },
    );
  });
}

export function signInWithPassword(credentials: { username: string; password: string }) {
  const previous = pendingSignIn;
  if (previous) return waitForPrevious(previous).then(() => signInWithPassword(credentials));
  const attempt = Promise.resolve().then(() => Auth.signIn(credentials));
  pendingSignIn = attempt;
  return attempt.finally(() => {
    if (pendingSignIn === attempt) pendingSignIn = null;
  });
}
